import { z } from "zod";

const emailSchema = z
  .string()
  .trim()
  .min(1, "Email address is required")
  .email("Invalid email address");

export const loginFormSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, "Password is required"),
});

export function createLoginFormSchema(allowedDomains: readonly string[]) {
  const normalizedDomains = allowedDomains.map((domain) =>
    domain.replace(/^@/, "").trim().toLowerCase(),
  );
  const domainList = normalizedDomains.map((domain) => `@${domain}`).join(" or ");

  return z.object({
    email: emailSchema.refine(
      (email) => {
        const parts = email.toLowerCase().split("@");
        // Let the standard email validator handle malformed addresses.
        if (parts.length !== 2 || parts[1] === "") return true;
        return normalizedDomains.includes(parts[1]);
      },
      { message: `Use an approved email domain: ${domainList}` },
    ),
    password: z.string().min(1, "Password is required"),
  });
}

export type LoginFormValues = z.infer<typeof loginFormSchema>;
